"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreventivatoreAutoService = void 0;
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const request_1 = require("../common/request");
class PreventivatoreAutoService {
    constructor() {
        this.commonNetworkService = new nodejs_library_1.CommonNetworkService();
        this.autoHeader = {
            "g-recaptcha-response": "",
        };
    }
    /**
     * POST BFF /transazioni:
     * Servizi BFF Evolutiva Consenso Privacy.
     * @param targa
     * @param birthdate
     * @param email
     * @param type
     * @param datiAgente
     * @param codAgenzia
     * @param cellulare
     * @param flagPrivacy
     * @param captcha
     * @param dataDecorrenza
     * @returns
     */
    postTransazioni(targa, birthdate, email, type, datiAgente, codAgenzia, cellulare, flagPrivacy, captcha, dataDecorrenza, codConvenzione = null) {
        return __awaiter(this, void 0, void 0, function* () {
            const convenzioneAutoStorage = yield nodejs_library_1.Helpers.SessionHelper.getData("convenzione_auto").catch(() => null);
            if (captcha) {
                this.autoHeader["x-token"] = captcha;
            }
            else {
                this.autoHeader["x-token"] = "";
            }
            const body = {
                km: 100000,
                email: email && email != "" ? email : null,
                settore: type ? type : "auto",
                tipoPersona: "F",
                codConvenzione: codConvenzione,
                //"cmpWeb": (cmpWeb && cmpWeb != '') ? cmpWeb : '',
                codAgenzia: codAgenzia && codAgenzia != "" ? codAgenzia : null,
                cellulare: cellulare && cellulare != "" ? cellulare : null,
                flagConsensoPrivacy: flagPrivacy && flagPrivacy != "" ? flagPrivacy : null,
                dataDecorrenza: dataDecorrenza && dataDecorrenza != "" ? dataDecorrenza : null,
            };
            if (targa != null && typeof targa != "undefined") {
                body["targa"] = targa;
            }
            if (birthdate != null && typeof birthdate != "undefined") {
                if (typeof birthdate != "string") {
                    birthdate = `${birthdate.getDay()}/${birthdate.getMonth()}/${birthdate.getFullYear()}`;
                }
                const d = birthdate.split("/");
                body["dataNascita"] = d[2] + "-" + d[1] + "-" + d[0];
            }
            else {
                body["dataNascita"] = null;
            }
            if (datiAgente != null && typeof datiAgente != "undefined") {
                body["codFiscale"] = datiAgente.codFiscale;
                body["token"] = datiAgente.token;
                body["timestamp"] = datiAgente.timestamp;
                body["tipoRichiesta"] = datiAgente.tipoRichiesta;
                body["codAgenzia"] = datiAgente.codAgenzia;
            }
            try {
                body.codConvenzione = JSON.parse(convenzioneAutoStorage).codice;
            }
            catch (e) {
                console.error(e);
            }
            const request = new request_1.Request("quotatori/auto/v2/transazioni", {
                body: body,
            });
            request.headers = this.autoHeader;
            return this.commonNetworkService.post(request.completeUrl, request.body, request.headers);
        });
    }
    /* scarica automaticamente il file, ritorna un booleano per la gestione dell'errore e del loading*/
    stampaPreventivo(idQuotazione) {
        const rq = new request_1.Request(`preventivatore/auto/v1/stampa/${idQuotazione}`, {
            headers: { "content-type": "application/pdf", accept: "application/pdf" },
        });
        const toRet = this.commonNetworkService
            .get(rq.completeUrl, rq.headers, true)
            .then((res) => res.blob())
            .catch((err) => Promise.reject(err));
        return toRet;
    }
}
exports.PreventivatoreAutoService = PreventivatoreAutoService;
